import { TrashIcon } from "djinn-components";
import React from "react";
import { FAQType } from "../../../types/api";

interface FAQEditFieldProps {
  value: FAQType;
  onChange: (val: FAQType) => void;
  invalid?: boolean;
  onDelete: () => void;
}
const FAQEditField: React.FC<FAQEditFieldProps> = ({
  value,
  onChange,
  invalid = false,
  onDelete,
}) => {
  return (
    <div className="mb-4 w-full p-2 rounded-md bg-gray-550 shadow-md relative">
      <input
        value={value.question}
        placeholder="Enter the question"
        className="bg-transparent w-full focus:ring-0 focus:outline-none font-semibold p-2 placeholder:text-gray-500"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          onChange({ question: e.target.value, answer: value.answer });
        }}
      />
      <textarea
        value={value.answer}
        placeholder="Enter the answer"
        className="bg-transparent w-full focus:ring-0 focus:outline-none font-light text-gray-300 px-2 placeholder:text-gray-450 text-sm"
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
          onChange({ answer: e.target.value, question: value.question });
        }}
      />

      <button
        type="button"
        className="block ml-2 absolute top-2 right-2"
        onClick={() => onDelete()}
      >
        <TrashIcon size={20} className="block text-white hover:text-red-700" />
      </button>
    </div>
  );
};

export default FAQEditField;
